import { Action } from '@ngrx/store';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';
import { TemplateType } from 'app/core/store/template/template.interface';
import { Definition } from '../definitions/definition.interface';
import { Definitions } from '../definitions/definitions.interface';
import { OrderDetailTO } from '../edit-florder-detail/florder-detail.interface';

export const ORDER_TEMPLATE_CREATE_START = 'template:ORDER_TEMPLATE_CREATE_START';
export const RELOCATION_TEMPLATE_CREATE_START = 'template:RELOCATION_TEMPLATE_CREATE_START';

export const TEMPLATE_COPY_FROM_ORDER = 'template:TEMPLATE_COPY_FROM_ORDER'; // copy order to template
export const TEMPLATE_COPY_FROM_ORDER_SUCCESS = 'template:TEMPLATE_COPY_FROM_ORDER_SUCCESS'; // copy order open order success for creat template

export const TEMPLATE_COPY_FROM_RELOCATION = 'template:TEMPLATE_COPY_FROM_RELOCATION'; // copy relocation to template
export const TEMPLATE_COPY_FROM_RELOCATION_SUCCESS = 'template:TEMPLATE_COPY_FROM_RELOCATION_SUCCESS'; // copy relocation to template success

export const TEMPLATES_LOAD = 'TEMPLATE:TEMPLATES_LOAD';
export const TEMPLATES_LOAD_FAIL = 'TEMPLATE:TEMPLATES_LOAD_FAIL';
export const TEMPLATES_LOAD_SUCCESS = 'TEMPLATE:TEMPLATES_LOAD_SUCCESS';

export const TEMPLATES_DELETE = 'TEMPLATE:TEMPLATES_DELETE';
export const TEMPLATES_DELETE_FAIL = 'TEMPLATE:TEMPLATES_DELETE_FAIL';
export const TEMPLATES_DELETE_SUCCESS = 'TEMPLATE:TEMPLATES_DELETE_SUCCESS';

export const TEMPLATES_START_EDIT = 'TEMPLATE:TEMPLATES_START_EDIT';
export const TEMPLATES_START_EDIT_FAIL = 'TEMPLATE:TEMPLATES_START_EDIT_FAIL';
export const TEMPLATES_START_EDIT_SUCCESS = 'TEMPLATE:TEMPLATES_START_EDIT_SUCCESS';

export const ORDER_TEMPLATE_EDIT = 'TEMPLATE:ORDER_TEMPLATE_EDIT';
export const RELOCATION_TEMPLATE_EDIT = 'TEMPLATE:RELOCATION_TEMPLATE_EDIT';

export class OrderTemplateCreateStartAction implements Action {
  readonly type = ORDER_TEMPLATE_CREATE_START;
  logPayload = true;

  constructor(readonly payload: { selectedCustomer: Definition; isSuperUser: boolean }) {} // activeCustomer
}

export class RelocationTemplateCreateStartAction implements Action {
  readonly type = RELOCATION_TEMPLATE_CREATE_START;
  logPayload = true;

  constructor(readonly payload: { selectedCustomer: Definition }) {} // activeCustomer
}

export class TemplateCreateFromOrderStartAction implements Action {
  readonly type = TEMPLATE_COPY_FROM_ORDER;
  logPayload = true;

  constructor(readonly payload: { etmOrderNumber: string }) {} // id
}

export class TemplateCreateFromOrderSuccessAction implements Action {
  readonly type = TEMPLATE_COPY_FROM_ORDER_SUCCESS;

  constructor(readonly payload: { definitions: Definitions; orderDetail: OrderDetailTO }) {}
}

export class TemplateCreateFromRelocationStartAction implements Action {
  readonly type = TEMPLATE_COPY_FROM_RELOCATION;

  constructor(readonly payload: { etmOrderNumber: string }) {} // id
}

export class TemplateCreateFromRelocationSuccessAction implements Action {
  readonly type = TEMPLATE_COPY_FROM_RELOCATION_SUCCESS;

  constructor(readonly payload: { definitions: Definitions; relocationDetail: OrderDetailTO }) {}
}

export class TemplatesLoadAction implements Action {
  readonly type = TEMPLATES_LOAD;
  logPayload = true;

  constructor(readonly payload: { type: TemplateType }) {}
}

export class TemplatesLoadSuccessAction implements Action {
  readonly type = TEMPLATES_LOAD_SUCCESS;

  constructor(readonly payload: any) {}
}

export class TemplatesLoadFailAction implements Action {
  readonly type = TEMPLATES_LOAD_FAIL;
  logPayload = true;

  constructor(readonly payload: any) {}
}

export class TemplatesDeleteAction implements Action {
  readonly type = TEMPLATES_DELETE;
  logPayload = true;

  constructor(readonly payload: { templateId: number; type: TemplateType }) {}
}

export class TemplatesDeleteSuccessAction implements Action {
  readonly type = TEMPLATES_DELETE_SUCCESS;
  logPayload = true;

  constructor(readonly payload: {  id: number, status: string, message?: string }) {}
}

export class TemplatesDeleteFailAction implements Action {
  readonly type = TEMPLATES_DELETE_FAIL;
  logPayload = true;

  constructor(readonly payload: any) {}
}

export class TemplatesStartEditAction implements Action {
  readonly type = TEMPLATES_START_EDIT;
  logPayload = true;

  constructor(readonly payload: { type: TemplateType; templateId: number }) {}
}

export class TemplatesStartEditSuccessAction implements Action {
  readonly type = TEMPLATES_START_EDIT_SUCCESS;

  constructor(readonly payload: { template: any; type: TemplateType }) {}
}

export class TemplatesStartEditFailAction implements Action {
  readonly type = TEMPLATES_START_EDIT_FAIL;
  logPayload = true;

  constructor(readonly payload: any) {}
}

export class OrderTemplateEditAction implements Action {
  readonly type = ORDER_TEMPLATE_EDIT;

  constructor(readonly payload: { template: any; definitions: Definitions; customer: Customer }) {}
}

export class RelocationTemplateEditAction implements Action {
  readonly type = RELOCATION_TEMPLATE_EDIT;

  constructor(readonly payload: { template: any }) {}
}

export type Actions =
  | OrderTemplateCreateStartAction
  | RelocationTemplateCreateStartAction
  | TemplateCreateFromOrderStartAction
  | TemplateCreateFromOrderSuccessAction
  | TemplateCreateFromRelocationStartAction
  | TemplateCreateFromRelocationSuccessAction
  | TemplatesLoadAction
  | TemplatesLoadSuccessAction
  | TemplatesLoadFailAction
  | TemplatesDeleteAction
  | TemplatesDeleteSuccessAction
  | TemplatesDeleteFailAction
  | TemplatesStartEditAction
  | TemplatesStartEditSuccessAction
  | TemplatesStartEditFailAction
  | OrderTemplateEditAction
  | RelocationTemplateEditAction;
